import { FormControl, FormGroup } from '@angular/forms';
import { ChannelType, EngagementStatus, MetadataColumns } from '../../../API';

export interface EngagementList {
  name: string;
  value: string;
  status: EngagementStatus;
}

export interface DataBaseTableItem {
  tableName: string;
  databaseName: string;
  datasourceName: string;
  columns: MetadataColumns[];
}

export interface CreateQueryRecordForm {
  engagement: FormControl<string>;
  orgType: FormControl<string>;
  name: FormControl<string>;
  description: FormControl<string>;
  query: FormControl<string>;
  type: FormControl<string>;
  createdBy: FormControl<string>;
}

export interface TypeDropdown {
  name: string;
  value: string;
}

export interface ValidationResponse {
  errors?: (string | null)[] | null;
  message?: string | null;
  warnings?: (string | null)[] | null;
}

export interface ChannelCredentials {
  appId: FormControl<string>;
  appSecret: FormControl<string>;
  appAccessToken: FormControl<string>;
  adAccountId: FormControl<string>;
}

export interface S3ChannelCredentials {
  bucketName?: FormControl<string>;
  awsRegion?: FormControl<string>;
  iamRoleArn?: FormControl<string>;
}

export interface CreateActivationChannelForm extends S3ChannelCredentials {
  channelType: FormControl<ChannelType>;
  createdBy: FormControl<string>;
  description: FormControl<string>;
  engagement: FormControl<string>;
  name: FormControl<string>;
  orgType: FormControl<string>;
  channelSecrets?: FormGroup;
}

export interface GetUserAccessTokenResponse {
  access_token: string;
  token_type: string;
}

interface GranularScope {
  scope: string;
}

interface DebugToken {
  app_id: string;
  type: string;
  application: string;
  data_access_expires_at: number;
  expires_at: number;
  is_valid: boolean;
  scopes: string[];
  granular_scopes: GranularScope[];
  user_id: string;
  error?: {
    code: string;
    message: string;
  };
}

export interface ValidateUserTokenResponse {
  data: DebugToken;
}
export enum GoogleMappings {
  EMAIL = 'Email',
  PHONE = 'Phone',
}

export const Mappings = [
  {
    title: 'Email',
    value: 'EMAIL',
    guidelines: 'Trim leading and trailing white space, and convert all characters to lowercase.',
  },
  {
    title: 'Phone',
    value: 'PHONE',
    guidelines:
      'Remove symbols, letters, and any leading zeroes. Prefix the country code if the COUNTRY field is not specified.',
  },
  {
    title: 'Gender',
    value: 'GEN',
    guidelines: 'Use these values: m for male, f for female.',
  },
  {
    title: 'Birth Year',
    value: 'DOBY',
    guidelines: 'Use the YYYY format: 1900 to the current year.',
  },
  {
    title: 'Birth Month',
    value: 'DOBM',
    guidelines: 'Use the MM format: 01 to 12.',
  },
  {
    title: 'Birth Day',
    value: 'DOBD',
    guidelines: 'Use the DD format: 01 to 31.',
  },
  {
    title: 'First Name',
    value: 'FN',
    guidelines: 'Use a-z only. Lowercase only, no punctuation. Special characters in UTF-8 format.',
  },
  {
    title: 'Last Name',
    value: 'LN',
    guidelines: 'Use a-z only. Lowercase only, no punctuation. Special characters in UTF-8 format.',
  },
  {
    title: 'First Name Initials',
    value: 'FI',
    guidelines: 'Use a-z only. Lowercase only. Special characters in UTF-8 format.',
  },
  {
    title: 'US States',
    value: 'ST',
    guidelines:
      'Use the 2-character ANSI abbreviation code, lowercase. Normalize states outside the US in lowercase, with no punctuation, no special characters, and no white space.',
  },
  {
    title: 'City',
    value: 'CT',
    guidelines: 'Use a-z only. Lowercase only, with no punctuation, no special characters, and no white space.',
  },
  {
    title: 'Zip Code',
    value: 'ZIP',
    guidelines:
      'Use lowercase, and no white space. For the US, use only the first 5 digits. For the UK, use the Area/District/Sector format.',
  },
  {
    title: 'Country Code',
    value: 'COUNTRY',
    guidelines: 'Use lowercase, 2-letter country codes in ISO 3166-1 alpha-2.',
  },
  {
    title: 'Mobile Advertiser ID',
    value: 'MADID',
    guidelines: 'Use all lowercase, and keep hyphens.',
  },
];
